module.exports = __webpack_public_path__ + "img/sw07.7879c5c1.jpg";